export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phoneDisplay: "(647) 949-5892",
  phoneHref: "tel:6479495892",
  email: "info@looxuryrentals.com",
  emailHref: "mailto:info@looxuryrentals.com",
  address: "Bradford",
  region: "Simcoe County & surrounding areas",
};

export const NAV_LINKS = [
  { label: "Why Us", href: "#why-us" },
  { label: "Trailers", href: "#trailers" },
  { label: "Gallery", href: "#gallery" },
  { label: "About", href: "#about" },
  { label: "Service Area", href: "#service-area" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const EVENT_TYPES = [
  "Wedding",
  "Corporate Event",
  "Festival",
  "Private Party",
  "Construction Project",
  "TV & Film Production",
  "Other",
];

export const TRAILERS = [
  {
    id: "sovereign",
    name: "The Sovereign",
    tag: "Flagship Suite Trailer",
    exterior: "/images/trailer-sovereign.png",
    interior: "/images/interior-suite.png",
    blurb:
      "Our flagship experience — a sweeping multi-suite trailer appointed with champagne bronze fixtures, bright vanities, and a quiet, climate-controlled interior that feels anything but temporary.",
    bestFor: "Weddings, galas & large corporate events",
    features: [
      "Private full-height suites",
      "Climate-controlled interior",
      "Running hot & cold water",
      "Bronze-accented vanities & mirrors",
      "Soft interior lighting",
      "Attendant-ready layout",
    ],
  },
  {
    id: "regent",
    name: "The Regent",
    tag: "Signature Event Trailer",
    exterior: "/images/trailer-regent.png",
    interior: "/images/interior-vanity.png",
    blurb:
      "A refined mid-size suite that balances capacity with elegance — warm lighting, a generous vanity, and finishes your guests will talk about for the right reasons.",
    bestFor: "Private parties, festivals & mid-size gatherings",
    features: [
      "Multiple private stalls",
      "Climate-controlled interior",
      "Running water vanities",
      "Framed mirrors & sconce lighting",
      "Premium fixtures throughout",
    ],
  },
  {
    id: "embassy",
    name: "The Embassy",
    tag: "Compact Luxury Trailer",
    exterior: "/images/trailer-embassy.png",
    interior: "/images/interior-detail.png",
    blurb:
      "Compact in footprint, uncompromising in finish. The Embassy slips discreetly into tight venues, production sets, and job sites while keeping every LooXury detail intact.",
    bestFor: "Film & TV sets, construction projects & intimate venues",
    features: [
      "Space-conscious footprint",
      "Climate-controlled interior",
      "Running water",
      "Champagne bronze detailing",
      "Quiet, discreet placement",
    ],
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Impeccable presentation",
    body: "Spotless, tastefully appointed trailers with champagne bronze accents — facilities that belong at a black-tie event, not behind it.",
  },
  {
    n: "02",
    title: "White-glove delivery",
    body: "We deliver, position, level, and dress each trailer before your first guest arrives — and collect it quietly when the last one leaves.",
  },
  {
    n: "03",
    title: "Comfort in any season",
    body: "Climate-controlled interiors, running water, and warm, flattering light. Spring weddings to winter production shoots, comfort never wavers.",
  },
  {
    n: "04",
    title: "Discreet & professional",
    body: "Quiet setups, polished exteriors, and a team that understands event etiquette — from estate weddings to working film sets.",
  },
  {
    n: "05",
    title: "Built for every occasion",
    body: "Weddings, corporate events, festivals, private parties, construction projects, and TV & film production — one fleet, every brief.",
  },
];

export const SERVICE_AREAS = [
  "Barrie",
  "Orillia",
  "Collingwood",
  "Wasaga Beach",
  "Midland",
  "Penetanguishene",
  "Innisfil",
  "Bradford West Gwillimbury",
  "New Tecumseth",
  "Springwater",
  "Clearview",
  "Oro-Medonte",
  "Essa",
  "Ramara",
  "Severn",
  "Tiny & Tay",
  "Adjala–Tosorontio",
  "& surrounding areas",
];

export const FAQS = [
  {
    q: "Which areas do you serve?",
    a: "We're based in Simcoe County and deliver throughout the county and surrounding areas. Delivery fees may apply depending on your venue's location — share your address when you request a quote and we'll confirm everything up front.",
  },
  {
    q: "How much does it cost to rent a trailer?",
    a: "Every event is different. Your quote depends on the trailer, your dates, the venue location, and the length of the rental. Request a quote and we'll put together exact pricing for your event — no obligation.",
  },
  {
    q: "What kinds of events do you cover?",
    a: "Weddings, corporate events, festivals, private parties, construction projects, and TV & film production sets. If people are gathering, we can keep them comfortable.",
  },
  {
    q: "How far in advance should I book?",
    a: "As early as you can — peak wedding and festival weekends fill quickly. That said, reach out any time; we'll always tell you honestly what's available for your dates.",
  },
  {
    q: "Do the trailers need power or water hookups?",
    a: "Requirements vary by trailer and venue. Tell us about your site when you book and we'll confirm exactly what's needed before delivery day.",
  },
  {
    q: "Can I see the trailers before I decide?",
    a: "Absolutely — browse the gallery, or get in touch and we'll walk you through the fleet, photos, and the best fit for your guest count and venue.",
  },
];

export const GALLERY = [
  { src: "/images/hero-trailer.png", caption: "Golden hour, estate wedding" },
  { src: "/images/trailer-regent.png", caption: "Vineyard events" },
  {
    src: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxmaWxtJTIwcHJvZHVjdGlvbiUyMHNldHxlbnwwfHx8fDE3ODcxNzU1MzB8MA&ixlib=rb-4.1.0&q=85",
    caption: "On set, on schedule",
  },
  { src: "/images/gallery-evening.png", caption: "Evening galas" },
  { src: "/images/gallery-exterior-new.png", caption: "Barn & vineyard venues" },
  { src: "/images/trailer-embassy.png", caption: "Compact, considered" },
];

export const MARQUEE_ITEMS = [
  "Weddings",
  "Corporate Events",
  "Festivals",
  "Private Parties",
  "Construction",
  "Film & TV Production",
];

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
